import { IOrder } from '../types/orders'
import { money } from './display'
import name from './name'
import { IBranch } from '../types/user'

export const orderTotal = (order: IOrder): string =>
  money(
    order.cost ||
      (order.orderItems || [])
        .reduce(
          (acct, i) => acct + i.amountRequested * +(i.effectivePrice || 0),
          0,
        )
        .toFixed(2),
  )

export const plannedCartTotal = (branch: IBranch): string =>
  money(
    (
      (branch!.suggestedCartItems!.length > 0 && branch.suggestedCartItems) ||
      []
    )
      .reduce((acct, i) => acct + i.amountPlanned * +(i.effectivePrice || 0), 0)
      .toFixed(2),
  )

export const cartTotal = (branch: IBranch): string =>
  money(
    (branch.cartItems || [])
      .reduce(
        (acct, i) => acct + i.amountRequested * +(i.effectivePrice || 0),
        0,
      )
      .toFixed(2),
  )

export const cartItemsAmount = (branch: IBranch): string =>
  branch!.cartItems!.length > 0
    ? branch!.cartItems!.length.toString()
    : branch!.suggestedCartItems!.length.toString()
